<template>
    <v-card>
      <v-row>
        <v-col cols="12">
          <v-card class="mb-5 pa-4">
            <v-card-title>
              <span class="headline">Goods Return Note #{{ grnDetails.goods_return_number }}</span>
            </v-card-title><br>
            <v-card-subtitle>
              <div>
                <strong>Po Number:</strong> {{grnDetails.po_number }}<br>
                <strong>Goods Return Date:</strong> {{grnDetails.goods_return_date }}<br>
                <strong>Supplier Name:</strong> {{grnDetails.supplier_name  }}<br>
                <strong>Reason For Return:</strong> {{ grnDetails.reason_for_return}}<br>
                <strong>Branch:</strong> {{ grnDetails.branch_name}}<br>
                <strong>Sub Total:</strong> {{ grnDetails.sub_total}}<br>
              </div>
            </v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
  
      <!-- Items Table -->
      <v-data-table
        v-if="items && items.length > 0"
        :headers="itemHeaders"
        :items="items"
        dense
        item-key="id"
      >
        <template v-slot:item="{ item, index }">
          <tr
            :class="[index % 2 === 0 ? 'dark-row' : 'light-row', 'custom-row']"
            @click="goToItemDetailPage(item)"
          >
            <td>{{item.product_code }}</td>
            <td>{{item.batch.batch_code }}</td>
            <td>{{item.stock_id}}</td>
            <td>{{item.condition}}</td>
            <td>{{item.quantity_returned}}</td>
            <td>{{item.unit_price }}</td>
            <td>{{item.total_price }}</td>
           
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </template>
  
  <script>
  import { GoodsReturnService } from "@/services/goodsReturn-service.js";
  export default {
    data() {
      return {
        grnDetails: {},  
        items: [],      
        loading: false,  
        itemHeaders: [
          { text: "Product Code", value: "product_code" },
          { text: "Batch Code", value: "product_code" },
          { text: "Stock Id", value: "stock_id" },
          { text: "condition", value: "condition" },
          { text: "Quantity", value: "quantity" },
          { text: "Unit Price", value: "unit_price" },
          { text: "Total Price", value: "total_price" },
        ],
      };
    },
    
    created(){
        this.fetchGrnDetails();
    },
    methods:{
        async fetchGrnDetails() {
      try {
       
        const response = await GoodsReturnService.getGrnDetails(this.$route.params.uuid);
        this.grnDetails = response;
        this.fetchItems(this.grnDetails.id);
      } catch (error) {
        console.error("Error fetching Goods Return Details:", error);
      }
    },

    async fetchItems(id) {
      try {
        const items = await GoodsReturnService.getItemsByGrnId(id);
        this.items = items; 
      } catch (error) {
        console.error("Error fetching items for Goods Return Note:", error);
      }
    },
    },
  };
  
  </script>
  <style scoped>
  .first-row {
    font-weight: bold;
  }
  
  .dark-row {
    background-color: #f4f4f4;
  }
  
  .light-row {
    background-color: #ffffff;
  }
  
  .custom-row:hover {
    background-color: #e8e8e8;
    cursor: pointer;
  }
  </style>
  